import React from 'react';
import { Link } from 'react-router-dom';

import aboutImg from '../../assets/images/about/ab.png'
import shapeImg from '../../assets/images/about/about-objective.jpeg'

const AboutPart = () => {

    return (
        <div className="about__area about__area_one p-relative pt---50 pb---50">
            <div className="container">
                <div className="row">
                    {/* <div className="col-lg-6">
                        <div className="about__image wow animate__fadeInUp" data-wow-duration="0.3s">
                            <div className='about__side_img___container me-5'>
                                <img className='img__1' width={500} height={600} src='./img/about/about-side-img1.png' alt='' />
                                <img className='img__2' width={500} height={300} src={shapeImg}  alt=''/>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12">
                        <div className="about__content pt-2">
                            <h2 className="about__title wow animate__fadeInUp text-center" data-wow-duration="0.3s">Organization Objectives<br />
                                {/* <em>Echooling LMS Platform</em> */}
                            </h2>
                            <p className="about__paragraph wow animate__fadeInUp" data-wow-duration="0.5s">
                                <h4>At OCFIT, we aim to:</h4>
                                <ul className='d-block mt-2' style={{ listStyle: "inside" }}>
                                    <li>Provide a wide range of programs and training based on the market requirement.</li>
                                    <li>Impart education through hi-tech software and machinery to enable students to use cutting-edge technology at work.</li>
                                    <li>Offer job opportunities.</li>
                                    <li>Invite superior faculty to train our students.</li>
                                    <li>Apart from training the local rural youth at OCFIT (Orient Craft Fashion Institute of Technology), we conduct training sessions at our factory-level training centers. These trainings are provided to workers who come with little or no skills at all.</li>
                                </ul>
                            </p>
                            

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutPart;